import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Dealer} from "domain-models"
import React from "react"
import Trans from '../../../../../components/Trans'

type ContactProps = {
  dealer: Dealer
}

class Contact extends React.Component<ContactProps> {
  render() {
    const dealer = this.props.dealer
    return (
      <div className="w-full flex flex-row flex-wrap mt-10 md:mt-0 text-gray-700">
        <span className='font-semibold text-lg text-gray-700 w-full'>
          <Icon icon="home"/> <Trans>Kontakt</Trans>
        </span>

        <div className="flex flex-col">
          <span className="font-semibold text-gray-800">{dealer.Firm}</span>
          <span>{dealer.FirmExtra}</span>
          <div className="flex flex-col md:flex-row">
            <span className="md:mx-1">
              <Icon icon="map-marker-alt"/> {dealer.Street}
            </span>
            <span className="md:mx-1 hidden md:block">/</span>
            <span className="md:mx-1">{dealer.PostalCode}, {dealer.City}</span>
          </div>
        </div>
      </div>
    )
  }
}

export default Contact
